const locationList = [
  "Downtown Toronto",
  "North York",
  "Richmond Hill",
  "Markham",
  "Scarborough",
  "Mississauga",
  "Vaughan",
  "Brampton",
  "Aurora",
  "Etobicoke",
].sort();

export default locationList;
